const initState = {
  pizzaMoneyAthletes: [],
  lastDocument: "",
  hasMoreDocument: true,
  pizzaMoneyDonations: [],
  fanBadges: [],
};
const pizzaMoneyReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_DONATIONS_DATA":
      return {
        ...state,
        pizzaMoneyDonations: action.payload,
      };
    case "PIZZA_MONEY_ATHLETES":
      return {
        ...state,
        pizzaMoneyAthletes: action.payload.data,
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "MORE_PIZZA_MONEY_ATHLETES":
      return {
        ...state,
        pizzaMoneyAthletes: [
          ...state.pizzaMoneyAthletes,
          ...action.payload.data,
        ],
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "DELETE_REQUEST":
      return {
        ...state,
        pizzaMoneyAthletes: state.pizzaMoneyAthletes.filter((data) => {
          return data.id !== action.payload;
        }),
      };
    case "EDIT_ATHLETE_STATUS":
      return {
        ...state,
        pizzaMoneyAthletes: state.pizzaMoneyAthletes.map((athlete) =>
          athlete.id === action.payload.id
            ? {
                ...athlete,
                athleteAction: action.payload.newStatus,
                status: action.payload.newStatus,
              }
            : athlete
        ),
      };
    case "FAN_BADGES":
      return {
        ...state,
        fanBadges: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default pizzaMoneyReducer;
